export const VIDEOS_ACTIONS = {
  INITIALIZE_VIDEOS: 'INITIALIZE_VIDEOS',
  INITIALIZE_VIDEOS_DATA: 'INITIALIZE_VIDEOS_DATA',
  UPDATE_HISTORY: 'UPDATE_HISTORY',
  CLEAR_HISTORY: 'CLEAR_HISTORY',
  UPDATE_PLAYLISTS: 'UPDATE_PLAYLISTS',
  TOGGLE_PLAYLIST_VIDEO: 'TOGGLE_PLAYLIST_VIDEO',
  TOGGLE_LIKED_VIDEO: 'TOGGLE_LIKED_VIDEO',
  TOGGLE_WATCH_LATER_VIDEO: 'TOGGLE_WATCH_LATER_VIDEO',
  RESET_VIDEOS_DATA: 'RESET_VIDEOS_DATA',
};
